import { v4 as uuid } from 'uuid';

function updateSubdomain (newSubdomain) {
    this.subdomain = newSubdomain;
    this.observed.subdomain = uuid();
    this.contentsStore.reloadSubdomain();
}

export default updateSubdomain;
